import React from 'react';
import TransactionalEmail from "@/components/transactional-email";

export default function EmailPreviewV4() {
  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-center mb-8">Email Transacional - Preview V4</h1>
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <TransactionalEmail
            userName="Maria Silva"
            courseName="Fundamentos de React e Next.js"
            courseDate="segunda-feira, 20 de janeiro de 2025"
            courseDuration="180 minutos"
            instructor="Prof. Carlos Santos"
            modality="Online"
            courseId="RN-2025-001"
            session="1ª aula"
            time="19:00 às 22:00"
            address="Aula 100% online"
            meetingLink="https://teams.microsoft.com/l/meetup-join/example"
            companyName="TechEdu Brasil"
          />
        </div>
      </div>
    </div>
  );
}
